import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './electronics.component.html',
	styleUrls: ['./electronics.component.css']
})

export class ElectronicsComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/electronics.component.ts